import React, { useRef, useEffect } from "react";
import { system, layout } from "styled-system";
import PropTypes from "prop-types";
import styled from "styled-components";

import { getHTMLDecodedText } from "util/chatUtil";

const StyledVideo = styled.video`
  ${system({
    objectFit: {
      property: "object-fit",
    },
  })}
  ${layout}
`;

const Video = ({
  src,
  srcHasBoth = false,
  controls,
  minifiedPoster = null,
  ...rest
}) => {
  const videoRef = useRef();

  useEffect(() => {
    return () => videoRef.current?.pause();
  }, []);

  return (
    <StyledVideo
      ref={videoRef}
      controls={controls}
      playsInline
      muted
      poster={
        minifiedPoster
          ? `/images/imagesV2/minifiedImages/${minifiedPoster}`
          : null
      }
      {...rest}
    >
      <source
        src={getHTMLDecodedText(srcHasBoth ? `${src}.webm` : src)}
        type="video/webm"
      />
      <source
        src={getHTMLDecodedText(srcHasBoth ? `${src}.mp4` : src)}
        type="video/mp4"
      />
      Sorry, your browser doesn&apos;t support embedded videos.
    </StyledVideo>
  );
};

Video.propTypes = {
  controls: PropTypes.bool,
};

Video.defaultProps = {
  controls: true,
};

export default Video;
